import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
import axios from "@/plugins/axios.js";
Vue.prototype.$http = axios; //方便每个组件都能使用，不需要重新引入
import 'amfe-flexible'
new Vue({
  render: h => h(App),
}).$mount('#app')
